export default {
    LBL_ACTION: 'Action',
    LBL_EXCEL_FILE: '(excel file)',
    LBL_REPORT: 'Report',
    LBL_REPORTS: 'Reports',
    LBL_LOADING_REPORT_INFORMATION: 'Loading reports...',
};
